import {
  TransactionDocumentUploadData,
  TransactionDocumentUploadResponseDTO,
} from '../../entities/TransactionDocuments';

const transactionDocumentUploadResponseDTOtoTransactionDocumentUploadAdapter = (
  response: TransactionDocumentUploadResponseDTO,
): TransactionDocumentUploadData => {
  if (!response.body) {
    throw Error();
  }

  const transactionUploadData = response.body;

  return new TransactionDocumentUploadData(transactionUploadData.referenceNumber, transactionUploadData.fileSn);
};

export { transactionDocumentUploadResponseDTOtoTransactionDocumentUploadAdapter };
